import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogHeader,
} from "@/components/ui/dialog";
import { Eye, Info, Trash2, PenLine } from "lucide-react";
import { Link } from "react-router-dom";
import { blackUser } from "@/assets";
import { format, parseISO, parse } from "date-fns";
import hasPermission from "@/hooks/hasPermission";

export function ReservationRqListTable({ data }) {
  const [isNoteOpen, setIsNoteOpen] = React.useState(false);
  const [selectedNote, setSelectedNote] = React.useState("");

  const statusColors = {
    draft: "text-gray-400",
    waiting: "text-yellow-300/70",
    confirmed: "text-cblue",
    cancelled: "text-cred",
    completed: "text-cgreen",
    on_show: "text-cyellow",
  };

  return (
    <>
      <Table className="w-full">
        <TableHeader>
          <TableRow>
            <TableHead className="w-[140px]">ID</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Type</TableHead>
            <TableHead>Reservation Date</TableHead>
            <TableHead>Issue Date</TableHead>
            <TableHead>Start Time</TableHead>
            <TableHead>End Time</TableHead>
            <TableHead>Guest</TableHead>
            <TableHead>Advance</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Note</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item?.unique_id || "N/A"}</TableCell>
                <TableCell>{item?.customer?.full_name || "N/A"}</TableCell>
                <TableCell>{item?.reservation_type == "phone" || item?.reservation_type == "phone_call" ? "Phone Call" : item?.reservation_type == "in_person" ? "In Person" : item?.reservation_type == "online" ? "Online" : item?.reservation_type == "other" ? "Other" : "N/A"}</TableCell>
                <TableCell>
                  {item?.reservation_date
                    ? format(parseISO(item?.reservation_date), "yyyy-MM-dd")
                    : "N/A"}
                </TableCell>
                <TableCell>
                  {item?.issue_date
                    ? format(parseISO(item?.issue_date), "yyyy-MM-dd")
                    : "N/A"}
                </TableCell>
                <TableCell>
                  {item?.start_date_time
                    ? format(parseISO(item?.start_date_time), "yyyy-MM-dd hh:mm a")
                    : "N/A"}
                </TableCell>
                <TableCell>
                  {item?.end_date_time
                    ? format(parseISO(item?.end_date_time), "yyyy-MM-dd hh:mm a")
                    : "N/A"}
                </TableCell>
                <TableCell>{item?.guest || "0"}</TableCell>
                <TableCell>{item?.advance || "0"}</TableCell>
                <TableCell
                  className={
                    statusColors[item?.status?.toLowerCase()] || "text-gray-300"
                  }
                >
                  {item?.status || "N/A"}
                </TableCell>
                <TableCell>
                  {" "}
                  <span>
                    <Eye
                      onClick={() => {
                        setSelectedNote(item?.note);
                        setIsNoteOpen(true);
                      }}
                      className="text-cwhite3 cursor-pointer"
                      size={18}
                    />
                  </span>
                </TableCell>
                <TableCell className="text-right justify-end flex gap-2 items-center">
                  <div className="flex items-center gap-2 h-10">
                    {/* {
                      hasPermission("reservation.reservation_request.reservation_view") && ( */}
                    <Link to={`/reservation/rq-details/${item?.id}`}>
                      <Eye className="text-cwhite3 cursor-pointer" size={18} />
                    </Link>
                    {/* )} */}
                    {
                      hasPermission("reservation.reservation_request.reservation_update") && (
                        <Link
                          to={"/reservation/reservation-request/update"}
                          state={item}
                          className="cursor-pointer"
                        >
                          <PenLine className="text-cyellow" size={18} />
                        </Link>
                      )}
                  </div>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={35} className="text-center">
                No data available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <NoteDialog
        note={selectedNote}
        isOpen={isNoteOpen}
        onClose={() => {
          setIsNoteOpen(false);
          setSelectedNote("");
        }}
      />
    </>
  );
}

export default ReservationRqListTable;

const NoteDialog = ({ note, isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Reservation Note</DialogTitle>
        </DialogHeader>
        <div className="">
          <p>{note || "No note available"}</p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
